export interface FieldValidationError {
  /** RHF-совместимый путь поля: 'analytics.0.parameters.parameters.event_handler.handler_id' */
  path: string;
  message: string;
}

const ERROR_PATTERN = /Path:\s*'([^']+)',\s*message:\s*'([^']*)'/g;

function normalizePath(path: string): string {
  return path.replace(/\[(\d+)\]/g, '.$1');
}

/**
 * Извлекает ошибки валидации полей из detail-строки ошибки artemy (400, error_code 12022).
 * Пример: "Failed to validate input json. Path: 'analytics[0].parameters...', message: '...'".
 */
export function parseValidationDetail(detail: string | undefined): FieldValidationError[] {
  if (!detail) return [];

  return Array.from(detail.matchAll(ERROR_PATTERN), (match) => ({
    path: normalizePath(match[1] ?? ''),
    message: match[2] ?? '',
  })).filter((error) => error.path !== '');
}
